import "@styles/tailwind.css";
import "@styles/variables.css";
import "@styles/global.css";
import "@src/utils/iframeResize";

import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { createRoot } from "react-dom/client";
import App from "./App";

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
});

Sentry.init({
  dsn: "https://38e50175c4b3a1a2396469fc52d241d3@o4505275731607552.ingest.us.sentry.io/4511151646244864",
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", "127.0.0.1", import.meta.env.VITE_API_BASEURL].filter(
    (value): value is string => Boolean(value),
  ),
  enableLogs: true,
});

const ROOT_ELEMENT_ID = "blazers-widget-ripcityrewards";
const container = document.getElementById(ROOT_ELEMENT_ID);

if (!container) {
  throw new Error(`Root element '${ROOT_ELEMENT_ID}' not found`);
}

const blazersWidget = createRoot(container);

blazersWidget.render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <App />
    </PostHogErrorBoundary>
  </PostHogProvider>,
);
